export default __webpack_public_path__ + "static/media/14-learning-notes.6727ef1a.png";